<template>
	<div class="layout-topbar">

		<div class="flex justify-content-between flex-wrap card-container" style="width: 100%">
			<div class="flex align-items-center justify-content-center">
				<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
					<i class="pi pi-bars" style="font-size: 1.5rem"></i>
				</button>
			</div>
			<div class="flex align-items-center justify-content-center">
				<button class="p-link layout-topbar-menu-button layout-topbar-button"
					v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
					leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
					<i class="pi pi-ellipsis-v"></i>
				</button>
			</div>

			<div class="flex align-items-center justify-content-center">

				<Button
					v-if="isLoggedIn"
					:label="'Logout in: ' + sessionCountdown"
					icon="pi pi-refresh"
					text
					plain
					:class="{ 'sh-session-refresh-btn--warning': sessionWarning }"
					class="sh-session-refresh-btn"
					@click="refreshSession"
					title="Sitzung verlängern"
				/>

				<button class="sh-layout-topbar-button" style="" @click="visibleNotifications = true" aria-controls="overlay_menu" aria-haspopup="true">
					<i v-badge="numUnreadNotifications.toString()" class="pi pi-bell p-overlay-badge" style="font-size: 1.5rem" />
				</button>

				<UserProfileMenue></UserProfileMenue>
			</div>
		</div>

		<Sidebar v-model:visible="visibleNotifications" position="right" class="w-8">
			<Notifications @close="handleClose" mode="notifications" />
		</Sidebar>
	</div>



</template>

<script>

import EventBus from './AppEventBus';
import Notifications from './components/NotificationSystem/Notifications.vue';
import UserProfileMenue from './components/UserProfileMenue.vue';
import Button from 'primevue/button';

export default {

	data() {
		return {
			visibleNotifications: false,
			sessionCountdown: '',
			sessionWarning: false,
			countdownInterval: null,
		}
	},

	components: {
		UserProfileMenue, Notifications, Button
	},

	emits: ['menu-toggle', 'topbar-menu-toggle'],
	outsideClickListener: null,
	themeChangeListener: null,
	watch: {
		$route() {
			if (this.active) {
				this.active = false;
				this.unbindOutsideClickListener();
			}
		},
		layoutMode(newValue) {
			this.d_layoutMode = newValue;
		},
	},
	beforeUnmount() {
		EventBus.off('theme-change', this.themeChangeListener);
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	},
	mounted() {
		this.themeChangeListener = () => {
			this.applyScale();
		};

		EventBus.on('theme-change', this.themeChangeListener);

		this.countdownInterval = setInterval(() => {
			this.updateCountdown();
		}, 1000);
		this.updateCountdown();
	},


    methods: {
		handleClose() {
			this.visibleNotifications = false;
		},

		async logoutUser() {
			await this.$router.push({ name: 'login' });
			this.$store.dispatch('logoutUser')
		},

		updateCountdown() {
			const expiresAt = this.$store.getters.getSessionExpiresAt;
			if (!expiresAt) {
				this.sessionCountdown = '';
				this.sessionWarning = false;
				return;
			}
			const remainingMs = expiresAt - Date.now();
			if (remainingMs <= 0) {
				this.sessionCountdown = '00:00';
				this.sessionWarning = true;
				return;
			}
			const totalSeconds = Math.floor(remainingMs / 1000);
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;
			this.sessionCountdown = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
			this.sessionWarning = totalSeconds < 10 * 60; // warn when < 10 minutes
		},

		async refreshSession() {
			try {
				await this.$store.dispatch('refreshUserToken');
				this.$store.dispatch('toastNotifications/notify', {
					severity: 'success',
					summary: 'Sitzung verlängert',
					detail: 'Ihre Sitzung wurde um 60 Minuten verlängert.',
					life: 4000,
				});
			} catch (e) {
				this.$store.dispatch('toastNotifications/notify', {
					severity: 'error',
					summary: 'Fehler',
					detail: 'Sitzung konnte nicht verlängert werden. Bitte loggen Sie sich erneut ein.',
					life: 5000,
				});
			}
		},

        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
		onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
		topbarImage() {
			return this.$appState.darkTheme ? 'images/logo_blue_white.svg' : 'images/logo_blue_dark.svg';
		},
			toggleConfigurator(event) {
				this.active = !this.active;
				event.preventDefault();

				if (this.active)
					this.bindOutsideClickListener();
				else
					this.unbindOutsideClickListener();
			},
			hideConfigurator(event) {
				this.active = false;
				this.unbindOutsideClickListener();
				event.preventDefault();
			},
			changeInputStyle(value) {
				this.$primevue.config.inputStyle = value;
			},
			changeRipple(value) {
				this.$primevue.config.ripple = value;
			},
			changeLayout(event, layoutMode) {
				this.$emit('layout-change', layoutMode);
				event.preventDefault();
			},
			bindOutsideClickListener() {
				if (!this.outsideClickListener) {
					this.outsideClickListener = (event) => {
						if (this.active && this.isOutsideClicked(event)) {
							this.active = false;
						}
					};
					document.addEventListener('click', this.outsideClickListener);
				}
			},
			unbindOutsideClickListener() {
				if (this.outsideClickListener) {
					document.removeEventListener('click', this.outsideClickListener);
					this.outsideClickListener = null;
				}
			},
			isOutsideClicked(event) {
				return !(this.$el.isSameNode(event.target) || this.$el.contains(event.target));
			},
			decrementScale() {
				this.scale--;
				this.applyScale();
			},
			incrementScale() {
				this.scale++;
				this.applyScale();
			},
			applyScale() {
				document.documentElement.style.fontSize = this.scale + 'px';
			},
			changeTheme(event, theme, dark) {
				EventBus.emit('theme-change', { theme: theme, dark: dark });
				event.preventDefault();
			}
    },
		changeTheme(event, theme, dark) {
			EventBus.emit('theme-change', { theme: theme, dark: dark });
			event.preventDefault();
	},
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		},

		isLoggedIn() {
			return this.$store.getters.getIsAuthenticated;
		},

		numUnreadNotifications(){
			let unreadNotif = this.$store.getters.getUnreadNotifications.filter((item) => {
                return item.type === "update"
            })
			return unreadNotif.length
		}

	}

}
</script>

<style scoped>
.sh-session-refresh-btn {
	margin-right: 0.5rem;
	font-size: 0.85rem;
	background-color: var(--surface-hover) !important;
	border-radius: 6px;
	color: var(--text-color) !important;
}

:deep(.sh-session-refresh-btn--warning) {
	color: #b45309 !important;
	background-color: #fef3c7 !important;
}
</style>
